import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		cardHeader: {
			padding: "10px 16px 0px 16px",
		},
		label: {
			textTransform: "none" as const,
			fontSize: 13,
			fontWeight: "bold",
		},
		reactivateButtonLabel: {
			textTransform: "none",
		},
		text: {
			paddingLeft: 5,
		},
		activeChip: {
			color: "white",
			backgroundColor: "#8fa638",
			fontSize: "1rem",
		},
		inactiveChip: {
			color: "black",
			backgroundColor: "#e0e0e0",
			fontSize: "1rem",
		},
		tagChip: {
			margin: 2,
		},
	} satisfies Record<string, CSSObject>;
};

